export async function uploadImage(file: File, token: string) {
  // 서버에서 Presigned URL 요청
  const response = await fetch(
    `${import.meta.env.VITE_API_URL}/api/chat/image/upload-url`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        fileName: file.name,
        contentType: file.type,
      }),
    },
  );

  const { uploadUrl, key } = await response.json();

  // Presigned URL로 R2에 직접 업로드
  // await로 대기하지 않고 백그라운드에서 업로드
  fetch(uploadUrl, {
    method: "PUT",
    body: file,
    headers: {
      "Content-Type": file.type,
    },
  });

  // 3. 메시지에 Workers URL 첨부
  const imageUrl = `https://lography.whitesnake.workers.dev/images/${key}`;
  return imageUrl; // https://your-worker.workers.dev/images/chat-images/123.jpg
}
